// this is an autogenerated file from App/Account/Content/Marketing/ReportTable/Content/Content/Content/LineChart/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Marketing_ReportTable_Content_Content_Content_LineChart(
  $locations: _uuid!
  $campaigns: _uuid
  $start_date: timestamptz
  $end_date: timestamptz
) {
  leads_get_history(
    args: {
      locations: $locations
      campaign_ids: $campaigns
      date_start: $start_date
      date_end: $end_date
    }
  ) {
    completed_date
    total
    incomplete
    created
    patient_created
  }
}

`